export const formatTimeMoscow = (isoString) => {
  if (!isoString) return '';
  try {
    const date = new Date(isoString);
    date.setHours(date.getHours() + 3);
    return date.toLocaleTimeString('ru-RU', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  } catch {
    return '';
  }
};

export const formatMessageDate = (isoString) => {
  if (!isoString) return '';
  try {
    const date = new Date(isoString);
    date.setHours(date.getHours() + 3);

    const today = new Date();
    today.setHours(today.getHours() + 3);

    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    if (date.toDateString() === today.toDateString()) return 'Сегодня';
    if (date.toDateString() === yesterday.toDateString()) return 'Вчера';

    return date.toLocaleDateString('ru-RU', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  } catch {
    return '';
  }
};

export const getMessageDateKey = (isoString) => {
  if (!isoString) return '';
  const date = new Date(isoString);
  date.setHours(date.getHours() + 3);
  return date.toDateString();
};

export const formatLastSeen = (lastSeenAgo) => {
  if (!lastSeenAgo) return '';
  const { unit, value } = lastSeenAgo;
  const map = {
    LESS_THAN_MINUTE: 'меньше минуты',
    MINUTE: 'минуту',
    MINUTES: 'минут',
    HOUR: 'час',
    HOURS: 'часов',
    DAY: 'день',
    DAYS: 'дней',
  };
  return `Был(а) ${value} ${map[unit] || unit.toLowerCase()} назад`;
};

export const formatInvitationDate = (isoString) => {
  if (!isoString) return '';
  try {
    return new Date(isoString).toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  } catch {
    return '';
  }
};

export const getExecutorIdFromChat = (chat) => {
  if (!chat) return null;
  return chat.selectedExecutorId || chat.executorId || chat.executor?.id || null;
};

export const getDisplayName = (chat, userRole) => {
  if (userRole === 'EXECUTOR') {
    return chat.displayCustomerName || chat.customer?.displayName || 'Пользователь';
  }

  return (
    chat.displaySelectedExecutorName ||
    chat.displayExecutorName ||
    chat.executor?.displayName ||
    'Исполнитель'
  );
};

export const getOrderTitle = (chat) => {
  return chat?.order?.title || chat?.displayOrderName || chat?.orderTitle || 'Название заказа';
};

export const getOnlineStatus = (chat, userRole) => {
  if (userRole === 'EXECUTOR') {
    if (chat.customer?.isOnline || chat.customerIsOnline) return 'В сети';
    if (chat.customer?.lastSeenAgo) return formatLastSeen(chat.customer.lastSeenAgo);
    if (chat.customerLastSeenAgo) return formatLastSeen(chat.customerLastSeenAgo);
    return 'Не в сети';
  }

  if (chat.selectedExecutorIsOnline || chat.executorIsOnline) return 'В сети';
  if (chat.selectedExecutorLastSeenAgo) return formatLastSeen(chat.selectedExecutorLastSeenAgo);
  if (chat.executorLastSeenAgo) return formatLastSeen(chat.executorLastSeenAgo);
  return 'Не в сети';
};

export const getIdsFromChat = (selectedChat, userRole, executorProfile, currentUserId) => {
  if (!selectedChat) {
    return { executorId: null, customerUserId: null, executorUserId: null };
  }

  let executorId = null;
  let customerUserId = null;
  let executorUserId = null;

  if (selectedChat.customer?.customerId) {
    customerUserId = selectedChat.customer.customerId;
  } else if (selectedChat.customerId) {
    customerUserId = selectedChat.customerId;
  }

  if (userRole !== 'EXECUTOR') {
    if (selectedChat.executor?.id) executorId = selectedChat.executor.id;
    if (selectedChat.executor?.userId) executorUserId = selectedChat.executor.userId;
    if (selectedChat.executorId) executorId = selectedChat.executorId;
  } else {
    if (executorProfile) {
      executorId = executorProfile.executorId;
      executorUserId = executorProfile.userId;
    } else {
      executorUserId = currentUserId;
      executorId = currentUserId;
    }
  }

  return { executorId, customerUserId, executorUserId };
};

export const getOrderIdFromChat = (selectedChat) => {
  if (!selectedChat) return null;
  return selectedChat.order?.orderId || selectedChat.orderId || null;
};

export const getChatLastMessageText = (chat, userRole) => {
  if (userRole === 'EXECUTOR') {
    return chat.lastMessageText
      ? chat.lastMessageText
      : chat.lastMessageAt
      ? 'Вложение'
      : 'Нет сообщений';
  }

  return chat.lastMessageText
    ? chat.lastMessageText
    : chat.lastMessageHasAttachments
    ? 'Фото'
    : 'Нет сообщений';
};
